<div class="login-container">
  <!-- Left Side - Image -->
  <app-left-ui [welcomeText]="'Welcome Back!'" [welcomeSubtitle]="'We build innovative software solutions that solve real-world problems and drive business transformation.'"></app-left-ui>

  <!-- Right Side - Form -->
  <div class="login-form">
    <a [routerLink]="['/']" class="btn home-btn">
      <i class="fa-solid fa-arrow-left"></i> Home
    </a>
    <div class="form-container">
      <div class="form-header">
        <h2 class="form-title">Sign In</h2>
        <p class="form-subtitle">
          Enter your credentials to access your account
        </p>
      </div>



      <div class="login-form-container">
        <form (ngSubmit)="onSubmit()" #loginForm="ngForm">
        <div class="form-group">
          <label for="usernameOrEmail">
            <i class="fa-solid fa-envelope me-2"></i>Email Address
          </label>
          <input
            type="email"
            id="usernameOrEmail"
            name="usernameOrEmail"
            placeholder="Enter your email"
            class="form-control"
            [(ngModel)]="loginModel.usernameOrEmail"
            required
            [disabled]="isLoading"
            #usernameOrEmail="ngModel" />
          <div
            *ngIf="
              usernameOrEmail.invalid &&
              (usernameOrEmail.dirty || usernameOrEmail.touched)
            "
            class="error-message">
            <small *ngIf="usernameOrEmail.errors?.['required']"
              >Email is required.</small
            >
          </div>
        </div>

        <div class="form-group mb-2">
          <label for="password">
            <i class="fa-solid fa-lock me-2"></i>Password
          </label>
          <div class="password-wrap">
            <input
              [type]="showPassword ? 'text' : 'password'"
              id="password"
              name="password"
              placeholder="Enter your password"
              class="form-control"
              [(ngModel)]="loginModel.password"
              required
              [disabled]="isLoading"
              #password="ngModel" />
            <button
              type="button"
              class="toggle-password"
              (click)="togglePasswordVisibility()"
              [attr.aria-label]="
                showPassword ? 'Hide password' : 'Show password'
              ">
              <i
                [ngClass]="
                  showPassword ? 'fa-solid fa-eye' : 'fa-solid fa-eye-slash'
                "></i>
            </button>
          </div>
          <div
            *ngIf="password.invalid && (password.dirty || password.touched)"
            class="error-message">
            <small *ngIf="password.errors?.['required']"
              >Password is required.</small
            >
          </div>
        </div>

        <div class="form-options">
          <div class="remember-me">
            <input
              type="checkbox"
              id="rememberMe"
              name="rememberMe"
              [(ngModel)]="rememberMe"
              [disabled]="isLoading" />
            <label for="rememberMe">Remember me</label>
          </div>
          <button
            type="button"
            class="forgot-password-link"
            (click)="navigateToForgotPassword()"
            [disabled]="isLoading">
            Forgot Password?
          </button>
        </div>

        <button
          type="submit"
          class="login-btn"
          [disabled]="loginForm.invalid || isLoading">
          <span *ngIf="!isLoading"> Sign In </span>
          <span *ngIf="isLoading">
            <i class="fa-solid fa-circle-notch fa-spin me-2"></i>Signing In...
          </span>
        </button>
        </form>
      <div class="divider">
        <span>Or continue with</span>
      </div>
      <div class="signup-link">
        Don't have an account?
        <button
          type="button"
          class="register-link"
          (click)="navigateToRegister()"
          [disabled]="isLoading">
          Sign up
        </button>
      </div>
    </div>
  </div>
</div>
